var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppinfoService } from './../../../services/appinfo.service';
import { CommonFunctionService } from './../../../services/common-function.service';
import { ContentJobsService } from './../content-jobs.service';
import { FieldMappingService } from './../../../services/field-mapping.service';
import { CommonTableService } from 'app/services/common-table.service';
import { LayerService } from 'app/services/layer.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { ConfirmModalComponent } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { UserService } from 'app/services/user.service';
import { EditService } from 'app/services/edit.service';
var JobsAddFilesComponent = /** @class */ (function () {
    function JobsAddFilesComponent(router, toastr, appinfoService, commonFuncService, editService, modalService, tableService, jobsService, fieldMappingService, layerService, userService) {
        this.router = router;
        this.toastr = toastr;
        this.appinfoService = appinfoService;
        this.commonFuncService = commonFuncService;
        this.editService = editService;
        this.modalService = modalService;
        this.tableService = tableService;
        this.jobsService = jobsService;
        this.fieldMappingService = fieldMappingService;
        this.layerService = layerService;
        this.userService = userService;
        // Preview
        this.previewRows = [];
        this.previewColumns = [];
    }
    JobsAddFilesComponent.prototype.loadFiles = function (files) {
        return __awaiter(this, void 0, void 0, function () {
            var rsp, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.commonFuncService.setLoadingSpinner(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.jobsService.transformLoadedFiles(files)];
                    case 2:
                        rsp = _a.sent();
                        this.handleLoadFiles(rsp);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.handleLoadFilesError();
                        this.toastr.error(err_1.message);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonFuncService.setLoadingSpinner(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    // This func is for both loadFiles and onDropFiles
    JobsAddFilesComponent.prototype.handleLoadFiles = function (data) {
        var _this = this;
        var promises = []; // Promises for selecting layers
        if (data.fgdbZip) {
            var _loop_1 = function (fgdb) {
                var promiseFgdbZip = new Promise(function (resolveFgdbZip, rejectFgdbZip) {
                    _this.jobsService.openLayerSelectWindow({
                        fgdb: fgdb,
                        layers: Object.keys(data.fgdbZip[fgdb].layers)
                    }, function (layers) {
                        // Cancel
                        layers = layers || [];
                        var layersUpdated = _this.jobsService.layers.getValue();
                        var _loop_5 = function (l) {
                            var existedLayer = layersUpdated.find(function (layer) {
                                return layer.name === l && layer.fileName === fgdb && layer.type === 'fgdbZip';
                            });
                            if (!existedLayer) {
                                if (layers.indexOf(l) !== -1) {
                                    // data.fgdbZip[fgdb].layers[l].selected = true;
                                    var content = data.fgdbZip[fgdb].layers[l];
                                    var cateGeomType = _this.getLayerCateGeomType(content.type);
                                    var cate = _this.setInitLayerCate(l, cateGeomType);
                                    var layer = {
                                        name: l,
                                        type: 'fgdbZip',
                                        fileName: fgdb,
                                        maintainType: cate.maintainType,
                                        category: cate.cateName,
                                        content: content,
                                        cateGeomType: cateGeomType
                                    };
                                    _this.addGeneralColType(layer);
                                    layersUpdated.push(layer);
                                }
                                else {
                                    // data.fgdbZip[fgdb].layers[l].selected = false;
                                    delete data.fgdbZip[fgdb].layers[l];
                                }
                            }
                        };
                        // Upload selected layers
                        for (var _i = 0, _a = Object.keys(data.fgdbZip[fgdb].layers); _i < _a.length; _i++) {
                            var l = _a[_i];
                            _loop_5(l);
                        }
                        _this.jobsService.layers.next(layersUpdated);
                        resolveFgdbZip();
                    });
                });
                promises.push(promiseFgdbZip);
            };
            for (var _i = 0, _a = Object.keys(data.fgdbZip); _i < _a.length; _i++) {
                var fgdb = _a[_i];
                _loop_1(fgdb);
            }
        }
        var layersUpdated = this.jobsService.layers.getValue();
        if (data.shp) {
            var _loop_2 = function (shp) {
                var existedLayer = layersUpdated.find(function (layer) {
                    return layer.name === shp && layer.type === 'shp';
                });
                if (!existedLayer) {
                    var content = data.shp[shp].info;
                    var cateGeomType = this_1.getLayerCateGeomType(content.type);
                    var cate = this_1.setInitLayerCate(shp, cateGeomType);
                    var layer = {
                        name: shp,
                        type: 'shp',
                        fileName: shp,
                        content: content,
                        cateGeomType: cateGeomType,
                        category: cate.cateName,
                        maintainType: cate.maintainType
                    };
                    this_1.addGeneralColType(layer);
                    layersUpdated.push(layer);
                }
            };
            var this_1 = this;
            for (var _b = 0, _c = Object.keys(data.shp); _b < _c.length; _b++) {
                var shp = _c[_b];
                _loop_2(shp);
            }
        }
        if (data.shpZip) {
            for (var _d = 0, _e = Object.keys(data.shpZip); _d < _e.length; _d++) {
                var zip = _e[_d];
                var _loop_3 = function (layer) {
                    var existedLayer = layersUpdated.find(function (l) {
                        return l.name === layer && l.type === 'shpZip';
                    });
                    if (!existedLayer) {
                        var content = data.shpZip[zip].layers[layer].info;
                        var cateGeomType = this_2.getLayerCateGeomType(content.type);
                        var cate = this_2.setInitLayerCate(layer, cateGeomType);
                        var l = {
                            name: layer,
                            type: 'shpZip',
                            fileName: zip,
                            content: content,
                            cateGeomType: cateGeomType,
                            category: cate.cateName,
                            maintainType: cate.maintainType
                        };
                        this_2.addGeneralColType(l);
                        layersUpdated.push(l);
                    }
                };
                var this_2 = this;
                for (var _f = 0, _g = Object.keys(data.shpZip[zip].layers); _f < _g.length; _f++) {
                    var layer = _g[_f];
                    _loop_3(layer);
                }
            }
        }
        if (data.fgdb) {
            var _loop_4 = function (name_1) {
                var promiseFgdb = new Promise(function (resolveFgdb, rejectFgdb) {
                    _this.jobsService.openLayerSelectWindow({
                        fgdb: name_1,
                        layers: Object.keys(data.fgdb[name_1].layers)
                    }, function (layers) {
                        // Cancel
                        // if (!layers) {
                        // 	delete data.fgdb[name];
                        // 	resolveFgdb();
                        // 	return;
                        // }
                        layers = layers || [];
                        var layersUpdatedFgdb = _this.jobsService.layers.getValue();
                        var _loop_6 = function (l) {
                            var existedLayer = layersUpdatedFgdb.find(function (layer) {
                                return layer.name === l && layer.fileName === name_1 && layer.type === 'fgdb';
                            });
                            if (!existedLayer) {
                                if (layers.indexOf(l) !== -1) {
                                    // data.fgdb[name].layers[l].selected = true;
                                    var content = data.fgdb[name_1].layers[l];
                                    var cateGeomType = _this.getLayerCateGeomType(content.type);
                                    var cate = _this.setInitLayerCate(l, cateGeomType);
                                    var layer = {
                                        name: l,
                                        type: 'fgdb',
                                        fileName: name_1,
                                        category: cate.cateName,
                                        maintainType: cate.maintainType,
                                        content: content,
                                        cateGeomType: cateGeomType
                                    };
                                    _this.addGeneralColType(layer);
                                    layersUpdatedFgdb.push(layer);
                                }
                                else {
                                    // data.fgdb[name].layers[l].selected = false;
                                    delete data.fgdb[name_1].layers[l];
                                }
                            }
                        };
                        // Upload selected layers
                        for (var _i = 0, _a = Object.keys(data.fgdb[name_1].layers); _i < _a.length; _i++) {
                            var l = _a[_i];
                            _loop_6(l);
                        }
                        _this.jobsService.layers.next(layersUpdatedFgdb);
                        resolveFgdb();
                    });
                });
                promises.push(promiseFgdb);
            };
            for (var _h = 0, _j = Object.keys(data.fgdb); _h < _j.length; _h++) {
                var name_1 = _j[_h];
                _loop_4(name_1);
            }
        }
        this.jobsService.layers.next(layersUpdated);
        Promise.all(promises)
            .catch()
            .then(function () {
            _this.jobsService.addRawFiles(data);
            _this.clickLayer(0);
        });
    };
    JobsAddFilesComponent.prototype.handleLoadFilesError = function () {
        this.toastr.error('Uploading failed.');
    };
    // Given loaed layer's geom type, get the available geomType of category
    JobsAddFilesComponent.prototype.getLayerCateGeomType = function (layerGeomType) {
        // switch (layerGeomType) {
        // 	case 'Point': return 'POINT';
        // 	case 'PolyLine': return 'LINE';
        // 	case 'Polygon': return 'AREA';
        // }
        // For cases like PolyLineZ:
        if (layerGeomType) {
            if (layerGeomType.toLowerCase().includes('point')) {
                return 'POINT';
            }
            else if (layerGeomType.toLowerCase().includes('polyline')) {
                return 'LINE';
            }
            else if (layerGeomType.toLowerCase().includes('polygon')) {
                return 'AREA';
            }
        }
    };
    // Convert field types to general
    JobsAddFilesComponent.prototype.addGeneralColType = function (layer) {
        var _this = this;
        if (layer.content.fields) {
            layer.content.fields.forEach(function (f) {
                f.generalColType = _this.appinfoService.findGeneralCol(f.LBType);
            });
        }
    };
    JobsAddFilesComponent.prototype.onDropFiles = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var rsp, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.items) return [3 /*break*/, 5];
                        this.commonFuncService.setLoadingSpinner(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.jobsService.transformDroppedFiles(data.items)];
                    case 2:
                        rsp = _a.sent();
                        this.handleLoadFiles(rsp);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        this.handleLoadFilesError();
                        this.toastr.error(err_2.message);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonFuncService.setLoadingSpinner(false);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    JobsAddFilesComponent.prototype.clickLayer = function (idx) {
        var layers = this.jobsService.layers.getValue();
        this.selectedLayer = layers[idx];
        if (this.selectedLayer && this.selectedLayer.content && this.selectedLayer.content.rows) {
            this.previewRows = this.selectedLayer.content.rows;
            if (!this.previewRows[0]) {
                this.previewColumns = [];
            }
            else {
                // const cols = [];
                // Object.keys(this.previewRows[0]).forEach((col) => {
                // 	cols.push({
                // 		name: col,
                // 		prop: col
                // 	});
                // });
                // this.previewColumns = cols;
                this.previewColumns = this.tableService.setColumnsFromRows(this.previewRows);
            }
        }
        else {
            this.previewRows = [];
            this.previewColumns = [];
        }
    };
    JobsAddFilesComponent.prototype.removeLayer = function (idx) {
        var layers = this.jobsService.layers.getValue();
        var layer = layers[idx];
        // Remove preview if selected
        if (layer === this.selectedLayer) {
            this.previewColumns = [];
            this.previewRows = [];
        }
        this.jobsService.removeRawFilesByLayer(layer);
        layers.splice(idx, 1);
        this.jobsService.layers.next(layers);
        // setTimeout(() => {
        // 	this.fileForm.form.updateValueAndValidity();
        // });
    };
    JobsAddFilesComponent.prototype.changeCate = function (layerIdx, cate) {
        return __awaiter(this, void 0, void 0, function () {
            var layers, layer, category, clearLayerCate, prevLoadedLayerName, options, data, result, err_3, layerWithSameCate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layers = this.jobsService.layers.getValue();
                        layer = layers[layerIdx];
                        category = this.categoryList.find(function (c) { return c.name === cate; });
                        layer.maintainType = category.layerMaintainType;
                        clearLayerCate = function (l) {
                            l.category = null;
                            l.maintainType = null;
                        };
                        // Check if the selected category has submitted-layer or not
                        if (category.hasSubmitted || category.hasApproved) {
                            setTimeout(function () { return clearLayerCate(layer); });
                            this.toastr.warning(category.name + ' layer is already submitted.');
                            return [2 /*return*/];
                        }
                        //
                        this.commonFuncService.setLoadingSpinner(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        // Check the last loaded file name of the selected category
                        if (category.hasSubmitted || category.hasApproved) {
                        }
                        prevLoadedLayerName = category.prevMappedLayerName;
                        if (!prevLoadedLayerName) return [3 /*break*/, 3];
                        if (!(prevLoadedLayerName !== layers[layerIdx].name)) return [3 /*break*/, 3];
                        options = {
                            height: '250px',
                            width: '520px'
                        };
                        data = {
                            title: 'Warning!',
                            message: 'The incoming layer name ' + layers[layerIdx].name +
                                ' is different from that of the existing layer ' + prevLoadedLayerName + '.'
                                + '\n\n Are you sure to proceed?',
                            yesBtnText: 'Ok',
                            noBtnText: 'Cancel'
                        };
                        options.data = data;
                        return [4 /*yield*/, this.modalService.openModalWindow(ConfirmModalComponent, options)];
                    case 2:
                        result = _a.sent();
                        if (!result) {
                            clearLayerCate(layer);
                            this.commonFuncService.setLoadingSpinner(false);
                            return [2 /*return*/];
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        this.commonFuncService.setLoadingSpinner(false);
                        layerWithSameCate = layers.find(function (l, idx) {
                            return l.category === cate && idx !== layerIdx;
                        });
                        if (layerWithSameCate) {
                            clearLayerCate(layerWithSameCate);
                        }
                        this.jobsService.layers.next(layers);
                        return [2 /*return*/];
                }
            });
        });
    };
    JobsAddFilesComponent.prototype.updateCatePrevLayer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var prevMapping;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fieldMappingService.getPrevMapping()];
                    case 1:
                        prevMapping = _a.sent();
                        this.categoryList.forEach(function (c) {
                            var prev = prevMapping.find(function (m) { return c.id === m.cateId; });
                            if (prev) {
                                c.prevMappedLayerName = prev.prevLayerName;
                            }
                            else {
                                c.prevMappedLayerName = null;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    JobsAddFilesComponent.prototype.setInitLayerCate = function (layerName, cateGeomType) {
        var category = this.categoryList.find(function (c) { return c.prevMappedLayerName === layerName && c.geomType === cateGeomType; });
        if (!category) {
            // Check geomType, match POINT -> address, LINE -> centerline
            // Because there's only one layer category with LINE/POINT
            var currLayers = this.jobsService.layers.getValue();
            if (cateGeomType === 'LINE' || cateGeomType === 'POINT') {
                var layerWithSameGeomType = currLayers.find(function (l) { return l.cateGeomType === cateGeomType; });
                if (!layerWithSameGeomType) {
                    category = this.categoryList.find(function (c) { return c.geomType === cateGeomType; });
                }
            }
        }
        var cateName, maintainType;
        if (category && !category.hasSubmitted && !category.hasApproved) {
            cateName = category.name;
            maintainType = category.layerMaintainType;
        }
        return {
            cateName: cateName,
            maintainType: maintainType
        };
    };
    // Allow overriding previously loaded layer or not for enterprised user
    JobsAddFilesComponent.prototype.checkPrevLoadedLayer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var layers, prevLoadedLayers, options, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.userService.userSubscription.subLevel !== this.editService.editRequiredSubLevel) {
                            return [2 /*return*/, true];
                        }
                        layers = this.jobsService.layers.getValue();
                        prevLoadedLayers = layers.filter(function (l) {
                            var cate = _this.categoryList.find(function (c) { return c.name === l.category; });
                            if (cate && cate.layerState.num >= 1) {
                                return true;
                            }
                        });
                        if (!(prevLoadedLayers.length > 0)) return [3 /*break*/, 2];
                        options = {
                            height: '250px',
                            width: '520px'
                        };
                        data = {
                            title: 'Warning!',
                            message: 'This upload will result in over-writing the following layers: ' + prevLoadedLayers.map(function (l) { return l.category; }).join(',') + '. '
                                + '\n\n OK to continue?',
                            yesBtnText: 'Ok',
                            noBtnText: 'Cancel'
                        };
                        options.data = data;
                        return [4 /*yield*/, this.modalService.openModalWindow(ConfirmModalComponent, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, true];
                }
            });
        });
    };
    JobsAddFilesComponent.prototype.goNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkPrevLoadedLayer()];
                    case 1:
                        rsp = _a.sent();
                        if (!rsp) {
                            return [2 /*return*/];
                        }
                        // this.stateService.go('jobsfieldmapping');
                        this.router.navigate(['azgiv/jobs/field-mapping']);
                        return [2 /*return*/];
                }
            });
        });
    };
    JobsAddFilesComponent.prototype.trackByFn = function (idx) {
        return idx;
    };
    JobsAddFilesComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userSubId, loadableList, list, layers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // On Wizard Mode
                        this.jobsService.wizard = 'on';
                        //
                        this.layers = this.jobsService.layers.asObservable();
                        userSubId = this.userService.getUserInfo().userSubId;
                        return [4 /*yield*/, this.layerService.getLoadableLayerTypeList(userSubId)];
                    case 1:
                        loadableList = _a.sent();
                        list = [];
                        this.appinfoService.layerTypeList.forEach(function (t) {
                            var loadableLayer = loadableList.find(function (i) { return t.code === i.code; });
                            if (!loadableLayer || !loadableLayer.loadable) {
                                return;
                            }
                            var layer = _this.layerService.layerListBS.getValue().layers.find(function (l) { return l.category.code === t.code; });
                            var hasSubmitted = false;
                            var hasApproved = false;
                            if (layer) {
                                if (layer.state.name === 'SUBMIT') {
                                    hasSubmitted = true;
                                }
                                else if (layer.state.name === 'APPROVE') {
                                    hasApproved = true;
                                }
                            }
                            var layerCate = Object.assign({
                                hasSubmitted: hasSubmitted,
                                hasApproved: hasApproved,
                                layerState: layer ? layer.state : null,
                                layerMaintainType: loadableLayer.maintainType
                            }, t);
                            list.push(layerCate);
                        });
                        this.categoryList = list;
                        // this.categoryList = this.appinfoService.layerTypeList.map((t) => {
                        // 	const layer = this.layerService.layerList.find((l) => l.category.code === t.code);
                        // 	let hasSubmitted = false;
                        // 	let hasApproved = false;
                        // 	if (layer) {
                        // 		if (layer.state === 3) {
                        // 			hasSubmitted = true
                        // 		} else if (layer.state === 5) {
                        // 			hasApproved = true;
                        // 		}
                        // 	}
                        // 	return Object.assign({
                        // 		hasSubmitted: hasSubmitted,
                        // 		hasApproved: hasApproved,
                        // 		layerState: layer ? layer.state : null
                        // 	}, t);
                        // });
                        this.selectedCusSub = this.userService.selectedCustomer.subscribe(function (cus) {
                            if (cus) {
                                _this.updateCatePrevLayer();
                            }
                        });
                        layers = this.jobsService.layers.getValue();
                        this.selectedLayer = layers[0];
                        return [2 /*return*/];
                }
            });
        });
    };
    JobsAddFilesComponent.prototype.ngOnDestroy = function () {
        this.selectedCusSub.unsubscribe();
    };
    return JobsAddFilesComponent;
}());
export { JobsAddFilesComponent };
